<div class="desktop-container" [ngClass]="{'last': isLast}">
    <div>
        <span class="intro">
            @if (audit; as audit) {
                <div>
                    <h3 class="p-0 m-0">{{ getTitle() }}</h3>
                    <div class="flex items-center gap-2">
                        <p>Due Date <b>{{ dateUtils.formatDateWithConditionalYear(getDueDate()) }}.</b></p>
                        <p>Status: <b>{{ getStatus() }}</b></p>
                    </div>
                </div>
            }
        </span>
    </div>
    <div class="form-type type-audit">
        Internal Audit
    </div>
    <a [routerLink]="['/assurance/internal-audit', audit._id]">
        <button class="btn btn-secondary btn-sm">View</button>
    </a>
</div>
